/* globals shuffle L jQuery contra Cookies MicroModal key */

/**
 * World Map
 */

import shuffle from './shuffle.js'
import { countryData } from '../countryData.js'
;(function ($) {
  const map = L.map('map', {
    zoom: 4,
    center: [18, -40],
    gestureHandling: true,
    zoomControl: false
  })

  L.control
    .zoom({
      zoomInText: '<span>zoom in</span>',
      zoomOutText: '<span>zoom out</span>'
    })
    .addTo(map)

  L.geoJson(countryData, {
    style: {
      weight: 0.5,
      opacity: 1,
      color: '#82aa9f',
      fillColor: '#f6f6f6',
      fillOpacity: 1
    }
  }).addTo(map)

  map.createPane('labels')
  map.getPane('labels').style.zIndex = 500
  // map.getPane('labels').style.pointerEvents = 'none'

  L.tileLayer(
    'https://stamen-tiles-{s}.a.ssl.fastly.net/toner-labels/{z}/{x}/{y}{r}.{ext}',
    {
      attribution:
        'Map tiles by <a href="http://stamen.com">Stamen Design</a>, <a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a> &mdash; Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      subdomains: 'abcd',
      minZoom: 1,
      maxZoom: 5,
      ext: 'png',
      noWrap: true,
      pane: 'labels'
    }
  ).addTo(map)

  // when popup is opened, lock tab focus
  key('tab, shift+tab', 'popup', function (e) {
    return false
  })

  key('esc', 'popup', function (e) {
    map.closePopup()
    key.setScope('all')
  })

  const markers = shuffle(window.mapData)
  const markerAnimation = []
  const markerGroup = new L.featureGroup()
  const shapeGroup = new L.featureGroup()

  const toggleShapes = {
    show (shape, marker) {
      shape.setStyle({
        fillOpacity: 0.5,
        opacity: 1
      })
      if (marker) {
        marker.setZIndexOffset(1000)
      }
    },
    hide (shape, marker) {
      shape.setStyle({
        fillOpacity: 0,
        opacity: 0
      })
      if (marker) {
        marker.setZIndexOffset(700)
      }
    }
  }

  $.each(markers, function (i, object) {
    const markup = `<a class="active" href="${object.url}"><img src="${object.thumb}" alt="" role="presentation"><span>${object.title}</span></a>`

    const divIcon = L.divIcon({
      iconSize: [80, 80],
      iconAnchor: [40, 40],
      popupAnchor: [85, 33],
      className: 'world-map-marker',
      html: `<img src="${object.thumb}" alt="${object.title}" title="${object.title}" aria-label="${object.description}">`
    })

    const marker = L.marker(object.latlng, {
      icon: divIcon,
      // riseOnHover: true,
      // riseOnFocus: true,
      autoPan: true,
      title: object.title
    }).bindPopup(markup, {
      autoPan: true,
      keepInView: false,
      closeButton: false,
      closeOnEscapeKey: true,
      className: 'world-map-popup',
      minWidth: 250,
      maxWidth: 250,
      minHeight: 80,
      maxHeight: 80
    })

    marker.addTo(markerGroup)

    markerAnimation[i] = function (next) {
      setTimeout(function () {
        L.DomUtil.addClass(marker._icon, 'is-added')
        next(null, i)
      }, 100)
    }

    if ('shape' in object) {
      $.getJSON(object.shape.data, function (data) {
        const shape = L.geoJson(data, {
          style: {
            fillColor: '#E16309',
            color: '#222', // stroke
            fillOpacity: 0,
            opacity: 0,
            weight: 1.5
          }
        }).addTo(shapeGroup)

        markers[i].shape = shape

        marker._icon.addEventListener('focus', e =>
          toggleShapes.show(shape, marker)
        )
        marker._icon.addEventListener('blur', e =>
          toggleShapes.hide(shape, marker)
        )
        marker.on('mouseover', e => toggleShapes.show(shape, marker))
        marker.on('mouseout', e => toggleShapes.hide(shape, marker))
      })
    }

    markers[i].idx = i
    markers[i].marker = marker
    marker.settings = markers[i]
    marker.idx = i

    marker.on('add', () => {
      const ele = L.DomUtil.get(marker._icon)
      ele.setAttribute('role', 'button')
      ele.setAttribute('aria-expanded', 'false')
    })
  })

  shapeGroup.addTo(map)
  markerGroup.addTo(map)

  let bounds = markerGroup.getBounds()

  // for mobile browsers, use alternate bounds
  if (L.Browser.mobile) {
    bounds = [
      [76.01609366420996, -110.39062500000001],
      [-69.03714171275197, 26.367187500000004]
    ]
  }

  map.fitBounds(bounds)

  map.on('popupopen', function (e) {
    key.setScope('popup')
    const marker = e.popup._source

    L.DomUtil.addClass(marker._icon, 'has-popup')
    e.popup.getElement().querySelector('a').focus()
    toggleShapes.show(markers[marker.idx].shape)
    L.DomUtil.get(marker._icon).setAttribute('aria-expanded', 'true')
  })

  map.on('popupclose', function (e) {
    key.setScope('all')
    const marker = e.popup._source
    L.DomUtil.removeClass(marker._icon, 'has-popup')
    marker._icon.focus()
    L.DomUtil.get(marker._icon).setAttribute('aria-expanded', 'false')
  })

  // MARKER ANIMATION
  const animateMarkers = function () {
    contra.series(markerAnimation, function () {
      $('.world-map-marker.is-added').addClass('is-ready')
    })
  }

  let trap = focusTrap.createFocusTrap('#map-intro', {
    initialFocus: false,
    escapeDeactivates: false,
    clickOutsideDeactivates: false,
    returnFocusOnDeactivate: false
  })

  let restore = null

  const settings = {
    onShow: modal => {
      trap.activate()
      const dialog = modal.querySelector('div[role="dialog"]')
      restore = hideOthers(dialog)
      dialog.focus()
    },
    onClose: modal => {
      trap.deactivate()
      restore()
      Cookies.set('map-intro', 'seen')
      animateMarkers()
      // document.querySelector('#map').focus()
    },
    disableFocus: true,
    openTrigger: 'data-footer-pages-open',
    awaitOpenAnimation: true,
    awaitCloseAnimation: true
  }

  // INTRO MODAL AND/OR TRIGGER ANIMATION
  if (Cookies.get('map-intro') != 'seen') {
    MicroModal.show('map-intro', settings)
  } else {
    setTimeout(animateMarkers, 250)
  }

  key('shift+/', function () {
    MicroModal.show('map-intro', settings)
  })
})(jQuery)
